import SoftwareCategories from './SoftwareCategories'

export default SoftwareCategories
